const getQuickSightTopicURL = ({ username, topicIdList, themeList }, { observer, biRepo }) => {
  biRepo.getQuickSightTopicUrl(
    { username, topicIdList, themeList },
    {
      success: (response) => {
        if (response.getQuickSightTopicUrl.error) {
          observer.errorGettingUrl()
          return
        }
        observer.receiveQuickSightUrl(response.getQuickSightTopicUrl.data)
      },
      failure: () => {
        observer.errorGettingUrl()
      }
    }
  )
}

export default getQuickSightTopicURL
